module.exports = __webpack_public_path__ + "img/ethical-hacking-lite.d852960e.png";